import script from "./DocumentManagement.vue?vue&type=script&setup=true&lang=js"
export * from "./DocumentManagement.vue?vue&type=script&setup=true&lang=js"

import "./DocumentManagement.vue?vue&type=style&index=0&id=19b66ede&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-19b66ede"]])

export default __exports__